import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { DeviceSessionService } from '../services/device-session.service';

/**
 * Route guard that allows access only on enrolled devices with kiosk mode enabled.
 */
export const kioskDeviceGuard: CanActivateFn = () => {
	const router = inject(Router);
	const deviceSessionService = inject(DeviceSessionService);

	deviceSessionService.restoreCachedDevicePolicyRules();

	if (!deviceSessionService.hasDeviceEnrollment()) {
		return redirectToKioskForbidden(router, 'This device is not enrolled for kiosk mode.');
	}

	if (!deviceSessionService.isKioskModeAllowed()) {
		return redirectToKioskForbidden(router, 'This device is not enrolled for kiosk mode.');
	}

	return true;
};

/**
 * Redirects to the forbidden page with a kiosk-specific error message.
 *
 * @param {Router} router - Angular router instance.
 * @param {string} errorMessage - Message shown on the error page.
 * @return {boolean} Always false to block navigation.
 */
function redirectToKioskForbidden(router: Router, errorMessage: string): boolean {
	void router.navigate(['/error/403'], {
		state: {
			skipCanLeave: true,
			errorMessage
		}
	});
	return false;
}
